import React from 'react';
import { get, uniqueId } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Card, CardContent, Link } from '@material-ui/core';
import messages from 'containers/UploadDocuments/messages';
import { translate } from 'containers/services/translate';

import {
  formatDocument,
  getLiveDocumentViewUrl,
} from 'containers/UploadDocuments/utils';
export interface MaterialUploadDocumentsBlocProps {
  intl: IntlShape;
  policyInfo: any;
}
const Container = styled.div`
  &&.container {
    margin-bottom: 35px;
    background-color: skyblue;
  }
  .title {
    text-align: left;
    text-transform: inherit;
    font-size: 13px;
    font-weight: bold;
    white-space: nowrap;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 10px;
    color: #384164;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .headerContainer {
    display: flex;
    justify-content: space-between;
  }
  .documentsContainer {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
  }
  .documentContainer {
    width: 200px;
    height: 100px;
    background: #f7f7f7 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #0000001a;
    border-radius: 4px;
    margin-top: 24px;
    margin: 0 5px;
  }
  .documentTypeContainer {
    top: 394px;
    left: 328px;
    width: 200px;
    height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 4px 4px 0px 0px;
  }
  .documentTypeIndexed {
    padding: 16px;
    color: #02194e;
    font-size: 16px;
    font-weight: 600;
    display: flex;
  }
  .documentType {
    padding: 8px 17px;
    color: #02194e;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    position: absolute;
  }
  .documentTitle {
    padding: 12px 12px 0px;
    color: #02194e;
    font-size: 13px;
    font-weight: 600;
    display: flex;
  }
  .iconStyle {
    position: relative;
    top: 10px;
    left: 80%;
    cursor: pointer;
  }
  .recapDocumentType {
    padding: 0px 12px;
    font-weight: normal;
    display: flex;
    position: absolute;
    font-size: 13px;
    font-family: Roboto;
    color: #999999;
  }
  .indexed-docs-div {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Title = styled.p`
  text-align: left;
  text-transform: inherit;
  font-size: 24px;
  margin: 10px;
  font-weight: 500;
  font-family: Roboto;
  width: auto;
  color: #2b2727;
`;
const MaterialUploadDocumentsBloc: React.FC<MaterialUploadDocumentsBlocProps> = (
  props,
): JSX.Element => {
  return (
    <Container className="container">
      <Card>
        <CardContent>
          <div className="headerContainer">
            <Title>
              {translate({ ...messages.UploadDocumentsBlocRecapTitle }, props)}
            </Title>
          </div>
          {get(props.policyInfo, 'sagis.claims[0].ListDocsNotIndexed', []) && (
            <div>
              <div className="indexed-docs-div">
                {formatDocument(props.policyInfo).map(
                  (document: {
                    isIndexed: boolean;
                    documentId: string;
                    type: string;
                    name: string;
                    fileName: string;
                    path: string;
                  }) => (
                    <Link
                      href={getLiveDocumentViewUrl(
                        document.path,
                        document.fileName,
                        document.isIndexed,
                        document.documentId,
                      )}
                      underline="none"
                      target="_blank"
                    >
                      <div className="documentContainer" key={uniqueId()}>
                        <div className="documentTypeContainer">
                          <span className="documentTypeIndexed">
                            {document.isIndexed ? document.type : document.path}
                          </span>
                        </div>
                        <div className="documentTitle">
                          {document.isIndexed ? document.type : document.path}
                        </div>
                      </div>
                    </Link>
                  ),
                )}
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default injectIntl(MaterialUploadDocumentsBloc);
